import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ListTable from "../../../molecules/ListTable";
import { useAdminReviewResultList } from "../../../../api/admin/review/hooks";
import Button from "../../../atoms/Button";
import Modal from "../../../organisms/Modal";
import UserProfileSimple from "../../../molecules/UserProfileSimple";
import styled from "styled-components";
import Paging from "../../../organisms/Paging";

/**
 * 리뷰 결과 목록 (@@ 현재 사용하지 않는 페이지)
 * - 관리자용 화면
 */
const ReviewList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [pageNum, setPageNum] = useState(1);
    const [viewCount, setViewCount] = useState(15);
    const [revieweeList, setRevieweeList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { data: reviewResultList, isLoading, refetch } = useAdminReviewResultList(pageNum, viewCount);

    useEffect(() => {
        console.log("@@reviewResultList:", reviewResultList?.data);
    }, [reviewResultList]);

    const reviewerOpenHandler = (el) => {
        setRevieweeList([el.idx, el.reviewee]);
        setIsModalOpen(true);
    };

    return (
        <>
            <Modal title="리뷰 결과 확인" isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}>
                <ListTable>
                    <thead>
                        <tr>
                            <th style={{ width: "10%" }} className="center">번호</th>
                            <th style={{ width: "90%" }}>Knotter</th>
                        </tr>
                    </thead>
                    {revieweeList[1]?.map((el, seq) => (
                        <tbody>
                            <tr className="hover-row" key={el.idx} onClick={() => navigate(`/admin/review/result/detail/${revieweeList[0]}/${el.idx}`)}>
                                <td>{seq + 1}</td>
                                <td>
                                    <UserProfileSimple user={el} />
                                </td>
                            </tr>
                        </tbody>
                    ))}
                </ListTable>
            </Modal>

            <h2>리뷰 결과 목록</h2>

            <div>
                <ListTable>
                    <thead>
                        <tr>
                            <th style={{ width: "5%" }} className="center">번호</th>
                            <th style={{ width: "65%" }}>제목</th>
                            <th style={{ width: "10%" }}>생성 날짜</th>
                            <th style={{ width: "20%" }} className="center">기능</th>
                        </tr>
                    </thead>

                    <tbody>
                        {reviewResultList?.data?.review &&
                            reviewResultList?.data?.review.map((el, idx) => {
                                return (
                                    <tr key={el.idx} className={el.is_hide === "1" ? "is-hide" : ""}>
                                        <td>{idx + 1}</td>
                                        <td className="left">
                                            <span className={`status status-${el.status}`}>{el.is_hide === "1" ? "삭제" : el.status === "1" ? "대기" : el.status === "2" ? "진행" : el.status === "3" ? "확인" : el.status === "4" ? "종료" : null}</span>
                                            {el.title}
                                        </td>
                                        <td>{el.reg_date.split("T")[0]}</td>
                                        <td>
                                            <Button type="main" onClick={(e) => reviewerOpenHandler(el)}>
                                                결과 확인하기
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </ListTable>
            </div>

            <Paging total={reviewResultList?.data?.total} pageNumState={[pageNum, setPageNum]} viewCount={viewCount}></Paging>
        </>
    );
};

const ModalTitle = styled.h5`
    margin-bottom: 20px;
`;

export default ReviewList;
